  export const findRfiColorMeta = (input, rfisList) => {
    if (!input) return null;
    const val = typeof input === "object" ? input.value || input.label : input;
    let match = rfisList.find((r) => String(r.rfi_id) === String(val));
    if (!match)
      match = rfisList.find(
        (r) => (r.rfi_name || "").toLowerCase() === String(val).toLowerCase(),
      );
    if (!match) return null;
    return {
      bg: match.rfi_color_code_bg,
      text: match.rfi_color_code_text,
      border: match.rfi_color_code_border,
    };
  };